// Fields to be added as the Details/Cylinder Units/Turbocharging tabs are built out.
export interface EngineReport {
  id: string;
  reportNumber?: string;
  comments?: string;
  details: EngineReportDetails;
  cylinderUnits?: EngineReportCylinderUnits;
}

// Backend: MEReport.cylinder_units.cyl[] (CylinderUnit). Map snake_case when an API adapter is added.
export interface EngineReportCylinderUnit {
  exhaustTemperature?: number;
  pMax?: number;
  pComp?: number;
  fuelPumpIndex?: number;
  pIndicated?: number;
  cwOutletTemperature?: number;
  pistonCoolingTemperature?: number;
}

export interface EngineReportCylinderUnits {
  cyl: EngineReportCylinderUnit[];
}

export interface EngineReportDetails {
  // Index into vessel_specifications.engine.me_engines (or, for diesel-electric
  // propulsion vessels, vessel_specifications.prime_mover.propulsion_motors).
  // Type/MCR/Power/Current/KVA are always derived live from the vessel spec at
  // this index (see V1 mePerformance.controller.ts `getEngine`) - they are never
  // persisted on the report itself.
  mainEngine?: number;
  cwTempBeforeLoCool?: number;
  cwTempAfterLoCool?: number;
  htFwTempInlet?: number;
  htFwPressureInlet?: number;
  cwTempBeforeAirCooler?: number;
  cwTempAfterAirCooler?: number;
  loTempEngineInlet?: number;
  loTempThrustSegment?: number;
  loTempTcBlowerInlet?: number;
  // Persisted by the backend (and V1) as lo_temp_tc_turbine_inlet - there is no outlet field;
  // map explicitly when an API adapter is added.
  loTempTcTurbineOutlet?: number;
  loPressSystemOil?: number;
  loPressTurbineOil?: number;
  loPressCoolingOil?: number;
  specificCylLoConsumption?: number;
  reportFrom?: Date;
  reportTo?: Date;
  singleEngineRunning?: boolean;
  engineRpm?: number;
  totalRh?: number;
  indicatedPower?: number;
  governorIndex?: number;
  effectivePower?: number;
  shaftGeneratorPower?: number;
  kwhStart?: number;
  kwhEnd?: number;
  avgPower?: number;
  oilGrade?: number;
  densityAt15?: number;
  lcv?: number;
  viscosityAt40?: number;
  sulphurPercent?: number;
  fuelConsumption?: number;
  fuelOilPressure?: number;
  fuelOilTemperature?: number;
  fuelQualitySetting?: number;
  scavengeAirTemperature?: number;
  scavengeAirPressure?: number;
  airInletTemperature?: number;
  barometricPressure?: number;
  exhaustPressureBeforeTc?: number;
  exhaustPressureAfterTc?: number;
  turbineInletPressure?: number;
  turbineBackPressure?: number;
  pumpInlet?: number;
  mainPressure?: number;
  waveHeight?: number;
  beaufortScale?: number;
  averageDraught?: number;
  currentSpeed?: number;
  propellerSlip?: number;
  swashPlates?: (number | undefined)[];
}

export const SWASH_PLATE_COUNT = 3;
